import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge must know our custom scales (theme.css) or it treats
 * e.g. text-display and text-ink as conflicting/unknown classes.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'xs', 'sm', 'base', 'md', 'lg', 'xl', 'display'] }],
      shadow: [
        {
          shadow: [
            'focus',
            'thumb',
            'hover',
            'menu',
            'raise',
            'drawer',
            'modal',
            'fab',
            'glow',
            'hero',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
